import apiSlice from "./ApiSlice";

const courseApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // get all delivery dates
        getAllCourseData: builder.query({
            providesTags: ["course"],
            query: (body: PaginationPayloadType) => {
                return {
                    url: "/course",
                    method: "POST",
                    body,
                };
            },
        }),

        // delete delivery date
        deleteCourseById: builder.mutation({
            invalidatesTags: ["course"],
            query: (id: any) => ({
                url: `/course/${id}`,
                method: "DELETE",
            }),
        }),
        // add delivery date
        addCourse: builder.mutation({
            invalidatesTags: ["course"],
            query: (body) => ({
                url: `/course/add`,
                method: "POST",
                body,
            }),
        }),
        //get delivery date by Id
        getCourseById: builder.query({
            providesTags: ["course"],
            query: (id: string) => {
                return {
                    url: `/course/${id}`,
                    method: "GET",
                };
            },
        }),

        // update delivery date
        updateCourseById: builder.mutation({
            invalidatesTags: ["course"],
            query: ({ body, id }) => ({
                url: `/course/${id}`,
                method: "PUT",
                body,
            }),
        }),

        //get Course
        getAllCourse: builder.query({
            providesTags: ["course"],
            query: () => {
                return {
                    url: `/course`,
                    method: "GET",
                };
            },
        }),

        // change status of delivery date
        changeStatusCourseById: builder.mutation({
            invalidatesTags: ["course"],
            query: ({ body, id }) => ({
                url: `/course/status-change/${id}`,
                method: "PUT",
                body,
            }),
        }),
    }),
});

export const {
    useGetAllCourseDataQuery,
    useDeleteCourseByIdMutation,
    useAddCourseMutation,
    useGetAllCourseQuery,
    useGetCourseByIdQuery,
    useUpdateCourseByIdMutation,
    useChangeStatusCourseByIdMutation,
} = courseApi;
